import businessJourneyDetailView from './objects/dashboards/businessJourney/businessJourneyDetailView.json';
import businessJourneys from './objects/dashboards/businessJourney/businessJourneys.json';
import biqOverviewPage from './objects/dashboards/overview/biqOverviewPage.json';
import biqDashboardPageTitle from './objects/dashboards/common/biqDashboardPageTitle.json';
import biqTag from './objects/dashboards/common/biqTag.json';

export default [biqOverviewPage, businessJourneyDetailView, businessJourneys, biqDashboardPageTitle, biqTag];
